import { Link } from "react-router-dom";
import { channels, siteInfo } from "@/mocks/channels";
import { quotes } from "@/mocks/extra";

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-background-100/80">
      <div className="wrap grid gap-8 py-12 md:grid-cols-4 md:py-14">
        {/* 品牌区 */}
        <div className="md:col-span-1">
          <Link to="/" className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg text-background-50">
              <i className="ri-megaphone-line" aria-hidden="true" />
            </span>
            <span className="font-display text-xl text-foreground-900">{siteInfo.brand}</span>
          </Link>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">{siteInfo.intro}</p>
          <p className="mt-3 text-xs text-foreground-400">
            理性吃瓜 · 围观有度 · 观点多元
          </p>
        </div>

        {/* 频道 */}
        <div>
          <h4 className="mb-3 text-sm font-bold text-foreground-900">
            <Link to="/rank">频道广场</Link>
          </h4>
          <ul className="space-y-2.5 text-sm text-foreground-600">
            {channels.map((c) => (
              <li key={c.slug}>
                <Link to={`/channels/${c.slug}`} className="hover:text-primary-700">
                  {c.name}
                  <span className="ml-1 text-xs text-foreground-400">· {c.tagline}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* 快速入口 */}
        <div>
          <h4 className="mb-3 text-sm font-bold text-foreground-900">快速入口</h4>
          <ul className="space-y-2.5 text-sm text-foreground-600">
            <li>
              <Link to="/" className="hover:text-primary-700">
                首页 · 今日速览
              </Link>
            </li>
            <li>
              <Link to="/rank" className="hover:text-primary-700">
                全网热议榜
              </Link>
            </li>
            <li>
              <Link to="/about" className="hover:text-primary-700">
                关于我们
              </Link>
            </li>
            <li>
              <a href={`mailto:${siteInfo.mail}`} className="hover:text-primary-700" rel="nofollow">
                商务 / 投稿
              </a>
            </li>
          </ul>
        </div>

        {/* 一句金句 */}
        <div>
          <h4 className="mb-3 text-sm font-bold text-foreground-900">今天的一句</h4>
          <blockquote className="rounded-xl border-l-2 border-primary-400 bg-background-50 px-4 py-3 text-sm italic leading-relaxed text-foreground-600">
            {quotes[0].text}
          </blockquote>
          <p className="mt-2 text-right text-xs text-foreground-400">—— {quotes[0].author}</p>
        </div>
      </div>

      <div className="border-t border-background-200/70 bg-background-100">
        <div className="wrap flex flex-col items-center justify-between gap-2 py-5 text-xs text-foreground-500 sm:flex-row">
          <p>© {new Date().getFullYear()} {siteInfo.brand} · 观点聚合内容仅供参考，不构成任何建议</p>
          <p className="flex items-center gap-1">
            有热度，更要有态度
            <i className="ri-fire-fill text-primary-500" aria-hidden="true" />
          </p>
        </div>
      </div>
    </footer>
  );
}